import { useTourStore } from '@ice-web-app/shared-store';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Tour } from './components/Tour';

const DsTour = () => {
  const location = useLocation();
  const { tourProps, setTourProps } = useTourStore();

  useEffect(() => {
    if (tourProps.steps?.length || tourProps.isOpen) {
      setTourProps({
        steps: [],
        isOpen: false,
      });
    }
  }, [location.pathname]);

  return <Tour {...tourProps} steps={tourProps.steps?.length ? tourProps.steps : []} />;
};

export default DsTour;
